import { render, staticRenderFns } from "./customer-statement-filter.vue?vue&type=template&id=447465b1&scoped=true&"
import script from "./customer-statement-filter.vue?vue&type=script&lang=js&"
export * from "./customer-statement-filter.vue?vue&type=script&lang=js&"
import style0 from "./customer-statement-filter.vue?vue&type=style&index=0&id=447465b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447465b1",
  null
  
)

export default component.exports